import { useFormikContext } from 'formik'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'

import { QueueCountersAPI } from '@api/queueCountersAPI'

import { ID } from '@models/base'
import { Option } from '@models/option'

import { AsyncSelectField, AsyncSelectFieldProps } from '@components/Form/AsyncSelect/AsyncSelectField'

import { QueueNumberCompleteFormShape } from '../../QueueNumberCompleteForm/QueueNumberCompleteForm'

type Props<IsMulti extends boolean> = Omit<AsyncSelectFieldProps<IsMulti>, 'onSearch'> & {
  queueId: ID
}
const QueueCompleteCountersSelectField = <IsMulti extends boolean = false>({ queueId, ...props }: Props<IsMulti>) => {
  const intl = useIntl()
  const { values, setFieldValue } = useFormikContext<QueueNumberCompleteFormShape>()
  const searchDebounce = async (keyword: string) => {
    const counters = await QueueCountersAPI.getOptionsForQueueNumberCompleteForm(
      { phrase: keyword ? keyword : undefined },
      queueId
    ).then((r) => r.data?.nodes)

    if (!counters) {
      return []
    }

    return counters?.map(
      (counter) =>
        new Option({
          label: `${counter.name!} - ${counter.user ? counter.user.name : ''}`,
          value: counter.id!,
          data: counter,
        })
    )
  }

  useEffect(() => {
    setFieldValue('preferred_counter_id', undefined)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.next_queue_id])

  return (
    <AsyncSelectField
      {...props}
      key={values.next_queue_id?.value}
      onSearch={searchDebounce}
      noOptionsMessage={() => intl.formatMessage({ id: 'queue_node.not_found' })}
    />
  )
}

export { QueueCompleteCountersSelectField }
